// extracted by mini-css-extract-plugin
export var con = "band-module--con--3Fb_H";
export var main = "band-module--main--3Uq41";
export var content = "band-module--content--Q4uVy";
export var close = "band-module--close--YLVm9";